import './dropdown.css'
import './navbar.css'
import { Menu, MenuItem } from '@mui/material'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

function DropDown({ menuItems, children }) {
  const [dropdown, setDropdown] = useState(null)
  const open = Boolean(dropdown)
  const handleClick = (event) => {
    setDropdown(event.currentTarget)
  }
  const handleClose = () => {
    setDropdown(null)
  }
  return (
    <section>
      <div
        aria-controls={open ? 'dropdown-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        className="nav-links"
        id="dropdown-trigger"
        onMouseOver={handleClick}
        style={open ? {backgroundColor: '#3b62ae', borderRadius: '5px'} : {}}
      >
			  {children}
      </div>
      <Menu
        MenuListProps={{
          'aria-labelledby': 'dropdown-trigger',
        }}
        anchorEl={dropdown}
        id="dropdown-menu"
        onClose={handleClose}
        open={open}
      >
        {menuItems.map((item, index) => {
          return (
            <MenuItem key={index} onClick={handleClose}>
              <Link className="menu-items" to={item.path}>
                {item.title}
              </Link>
            </MenuItem>
          )
        })}
      </Menu>
    </section>
  )
}

export default DropDown
